import request from '@/router/axios';

export const getFormList = (currentPage, pageSize) => {
  return request({
    url: '/avue/form/getFormList',
    method: 'get',
    params: {
      currentPage,
      pageSize,
    },
  });
};
export const saveForm = (formData) => {
  return request({
    url: '/avue/form/save',
    method: 'post',
    data: {
      formData,
    },
  });
};
export const updateForm = (formData) => {
  return request({
    url: '/avue/form/update',
    method: 'post',
    data: {
      formData,
    },
  });
};

export const saveBindForm = (formType,data) => {
  return request({
    url: `/api/v4ward/custom/form/createForm/${formType}`,
    method: 'post',
    data: data,
  });
};

export const getFormById = (id) => {
  return request({
    url: '/avue/form/getFormById',
    method: 'post',
    data: {
      id,
    },
  });
};

export const getFormTemplateById = (formId,type) => {
  return request({
    url: `/api/v4ward/custom/form/detail/${type}`,
    method: 'get',
    params: {
      formId,
    },
  });
};

export const removePublicTable = (publicTableId) => {
  return request({
    url: `/v4ward/custom/table/public/remove/${publicTableId}`,
    method: 'get',
    params: {
      
    },
  });
};
export const removeExtendTable = (extendTableId) => {
  return request({
    url: `/v4ward/custom/table/extend/remove/${extendTableId}`,
    method: 'get',
    params: {
      
    },
  });
};

export const getFormTemplateByProjectId = (projectId,type,pageUrl) => {
  return request({
    url: `/api/v4ward/custom/form/pageActive/${type}`,
    method: 'get',
    params: {
      projectId,
      pageUrl
    },
  });
};

export const getFormTemplateByTableId = (type,tableId) => {
  return request({
    url: `/api/v4ward/custom/form/tableActive/${type}`,
    method: 'get',
    params: {
      tableId
    },
  });
};

export const getFormDataList = (id) => {
  return request({
    url: '/avue/form/getFormDataList',
    method: 'get',
    params: {
      id,
    },
  });
};

export const getPublicTableFormDataList = (tableId) => {
  return request({
    url: '/api/v4ward/custom/form/public/page',
    method: 'get',
    params: {
      tableId,
    },
  });
};

export const getExtendTableFormDataList = (tableId) => {
  return request({
    url: '/api/v4ward/custom/form/extend/page',
    method: 'get',
    params: {
      tableId,
    },
  });
};


export const handleExtendFormSwitchBtnStatus = (id,
  status,
  pageUrl,
  deptId,
  projectId) => {
  return request({
    url: '/api/v4ward/custom/form/extend-status',
    method: 'post',
    data: {
      id,
      status,
      pageUrl,
      deptId,projectId
    },
  });
};


export const handlePublicFormSwitchBtnStatus = (id,
  status,
  pageUrl,projectId) => {
  return request({
    url: '/api/v4ward/custom/form/public-status',
    method: 'post',
    data: {
      id,
      status,
      pageUrl,projectId
    },
  });
};


export const getTableFieldsDataList = (
  customType,
  pageUrl,
  deptId,
  tableId,
  projectId
  ) => {
  return request({
    url: '/api/v4ward/custom/form/table/detail',
    method: 'get',
    params: {
      customType,
      pageUrl,
      deptId,
      tableId,
      projectId
    },
  });
};


export const addFormData = (formData) => {
  return request({
    url: '/avue/form/data/add',
    method: 'post',
    data: {
      formData,
    },
  });
};

export const updateFormData = (formData) => {
  return request({
    url: '/avue/form/data/update',
    method: 'post',
    data: {
      formData,
    },
  });
};

export const deleteFormData = (formData) => {
  return request({
    url: '/avue/form/data/delete',
    method: 'post',
    data: {
      formData,
    },
  });
};


export const removeFormDesign = (customType,formId) => {
  return request({
    url: `/api/v4ward/custom/form/remove/${customType}/${formId}`,
    method: 'delete',
    params: {
      
    },
  });
};
